export default __webpack_public_path__ + "static/study-2-63273612fde9392dea51e2987fa691ff.jpg";